export default defineNuxtPlugin(() => {
	const config = useRuntimeConfig();

	const $apiFetch = $fetch.create({
		baseURL: config.public.baseUrl
	});

	return {
		provide: {
			apiFetch: $apiFetch
		}
	};
});
